import React, { FunctionComponent } from "react";
import cx from "classnames";
import styles from "./MenuItem.module.scss";
import { TabKeys } from "../../../data/tabs";
import { useMenu } from "../useMenu";

export interface DropDown {
  index: number;
  open: boolean;
  renderArrow: boolean;
  itemsFunction: () => React.JSX.Element;
}

export interface MenuItemProps {
  title: string;
  icon: React.JSX.Element | false;
  collapsible: DropDown | false;
  disabled: boolean;
  tabKey?: TabKeys;
  index?: number;
}

export const MenuItemComponent: FunctionComponent<MenuItemProps> = ({
  title,
  icon,
  collapsible,
  disabled,
  tabKey,
  index,
}: MenuItemProps): React.JSX.Element => {
  const { isMobile, onTabSelected, onDropDownToggled, isHamburgerOpen } =
    useMenu();

  const onMenuItemTriggered = (): void => {
    if (tabKey) {
      onTabSelected(tabKey);
    }
  };

  const { selectedTab } = useMenu();
  const isActive = tabKey === selectedTab;

  return (
    <li
      className={cx(styles["menu-item"], {
        [styles["active"] as string]: isActive,
        [styles["animate"] as string]: isHamburgerOpen,
        [styles["mobile-styled"] as string]: true,
      })}
      style={
        index !== undefined
          ? ({ "--item-index": index } as React.CSSProperties)
          : {}
      }
      onClick={onMenuItemTriggered}
      onKeyPress={onMenuItemTriggered}>
      {isMobile && (
        <>
          <div className={styles["corner-tr"]} />
          <div className={styles["corner-bl"]} />
        </>
      )}
      <button
        className={cx(styles["button-menu"], {
          [styles["disabled"] as string]: disabled,
        })}>
        {icon && icon}
        {title}
      </button>
    </li>
  );
};
